import React from 'react'
import './Toggle.css'

type toggle = {
  label: string
  onClick(value: boolean): void
  isToggleOn: boolean
}

const Toggle = ({ label, onClick, isToggleOn }: toggle) => {

  return (
    <div className="container">
      {label}{' '}
      <div className="toggle-switch">
        <input type="checkbox" className="checkbox" onChange={(event) => {
          onClick(!isToggleOn)
        }} checked={isToggleOn}
               name={label} id={label}></input>
        <label className="label" htmlFor={label}>
          <span className="inner"/>
          <span className="switch"/>
        </label>
      </div>
    </div>
  )


}


export default Toggle